import { Injectable, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ICONS } from '../constants/icons.constants';

@Injectable()
export class IconService {
  protected _matIconRegistry = inject(MatIconRegistry);
  protected _domSanitizer = inject(DomSanitizer);

  loadIcons(): void {
    const prefix = 'dgi';
    ICONS.forEach(iconName => {
      this._matIconRegistry.addSvgIcon(
        `${prefix}-${iconName}`,
        this._domSanitizer.bypassSecurityTrustResourceUrl(
          `assets/icons/${iconName}.svg`
        )
      );
    });
  }
}
